var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-table-cell-title",domProps:{"textContent":_vm._s(_vm.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }